export default "__VITE_ASSET__Buahe1Xx__"